import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full px-4 md:px-6 lg:px-10 py-14">
        <div className="flex flex-col lg:flex-row gap-12">
          <div className="lg:w-2/5">
            <Link to="/" className="inline-flex items-center gap-2 mb-5 cursor-pointer">
              <div className="w-10 h-10 flex items-center justify-center">
                <i className="ri-book-open-line text-2xl text-primary-400"></i>
              </div>
              <span className="text-2xl font-heading font-bold text-background-50">
                非麻瓜
              </span>
            </Link>
            <p className="text-foreground-300 text-sm leading-relaxed max-w-md mb-6">
              非麻瓜漫画——免费韩漫在线阅读平台，提供海量韩国漫画资源。支持下拉式阅读体验，每日更新最新韩漫全集，无需注册即可免费畅读热门韩国漫画。
            </p>
            <div className="flex items-center gap-3">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="微博">
                <i className="ri-weibo-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="微信">
                <i className="ri-wechat-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="B站">
                <i className="ri-bilibili-line text-base"></i>
              </a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full border border-foreground-600 text-foreground-400 hover:text-background-50 hover:border-background-50 transition-colors cursor-pointer" aria-label="小红书">
                <i className="ri-chat-smile-2-line text-base"></i>
              </a>
            </div>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-sm font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-col gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速链接</h4>
            <div className="flex flex-col gap-2">
              <Link to="/" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">首页</Link>
              <Link to="/category/all" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">全部漫画</Link>
              <Link to="/about" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">关于我们</Link>
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">用户协议</a>
              <a href="#" className="text-sm text-foreground-400 hover:text-background-50 transition-colors cursor-pointer">隐私政策</a>
            </div>
          </div>

          <div className="lg:w-1/5">
            <h4 className="text-sm font-semibold text-background-50 mb-4">联系我们</h4>
            <div className="flex flex-col gap-2">
              <p className="text-sm text-foreground-400">邮箱：hello@wa25w.cn</p>
              <p className="text-sm text-foreground-400">QQ群：888888888</p>
              <p className="text-sm text-foreground-400">工作时间：9:00 - 21:00</p>
            </div>
          </div>
        </div>
      </div>

      <div className="border-t border-foreground-800">
        <div className="w-full px-4 md:px-6 lg:px-10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 非麻瓜漫画 wa25w.cn 版权所有 | 本站内容仅供学习交流，请支持正版
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">用户协议</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">隐私政策</a>
            <a href="#" className="text-xs text-foreground-500 hover:text-foreground-300 transition-colors cursor-pointer">免责声明</a>
          </div>
        </div>
      </div>
    </footer>
  );
}